import { WebsiteWithConnections } from '../../types/website';
import { Card, Input } from '../ui';
import { InfoField, EmptyValue, WebsiteEditForm } from './WebsiteInfoPanel';

interface HostingInfoPanelProps {
  website: WebsiteWithConnections | null;
  isEditMode: boolean;
  editForm: WebsiteEditForm;
  setEditForm: (val: WebsiteEditForm) => void;
}

export default function HostingInfoPanel({ website, isEditMode, editForm, setEditForm }: HostingInfoPanelProps) {
  return (
    <Card eyebrow="Hosting">
      {isEditMode ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
          <Input
            label="Hosting Provider"
            placeholder="Netlify, Vercel, AWS, etc."
            value={editForm.hosting_provider}
            onChange={(e) => setEditForm({ ...editForm, hosting_provider: e.target.value })}
          />

          <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: 'var(--space-4)' }}>
            <Input
              label="Location"
              value={editForm.hosting_location}
              onChange={(e) => setEditForm({ ...editForm, hosting_location: e.target.value })}
            />
            <Input
              label="IP Address"
              value={editForm.ip_address}
              onChange={(e) => setEditForm({ ...editForm, ip_address: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: 'var(--space-4)' }}>
            <Input
              label="Username"
              value={editForm.hosting_username}
              onChange={(e) => setEditForm({ ...editForm, hosting_username: e.target.value })}
            />
            <Input
              label="Password"
              type="password"
              value={editForm.hosting_password}
              onChange={(e) => setEditForm({ ...editForm, hosting_password: e.target.value })}
            />
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: 'var(--space-5) var(--space-6)' }}>
          <InfoField label="Hosting Provider">
            {website?.hosting_provider || <EmptyValue />}
          </InfoField>

          <InfoField label="Location">
            {website?.hosting_location || <EmptyValue />}
          </InfoField>

          <InfoField label="Username" mono>
            {website?.hosting_username || <EmptyValue />}
          </InfoField>

          <InfoField label="Password" mono>
            {website?.hosting_password ? '••••••••' : <EmptyValue />}
          </InfoField>

          <InfoField label="IP Address" mono>
            {website?.ip_address || <EmptyValue />}
          </InfoField>
        </div>
      )}
    </Card>
  );
}
